import { gql } from '@apollo/client';

/******************************** CREATE ********************************/
export const CREATE_VIDEO_CALL_MUTATION = gql`
  mutation CreateVideoCallMutation($createVideoCallInput: CreateVideoCallInput!) {
    createVideoCall(createVideoCallInput: $createVideoCallInput) {
      ...on CreateVideoCallErrorOutput {
        errorReason
      },
      ...on CreateVideoCallOutput {
        videoCall {
          roomName
          participantEmails
        }
      }      
    }
  }
`;
